import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map, catchError } from 'rxjs/operators';
import { domain } from 'src/environments/environment';
import { GlobalProvider } from './global';
import { ToastController } from '@ionic/angular';
import { BaseHelper } from 'src/app/baseHelper';


@Injectable({
  providedIn: 'root',
})
export class BusinessApiService {
  constructor(private http: HttpClient, private g: GlobalProvider, private toastController: ToastController, private b: BaseHelper) { }
  getHeader = () => {
    return {
      headers: new HttpHeaders({
        Authorization: this.g.jws,
      }),
    };
  };

  namespace = 'business';
  async list(params = {}) {
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/list`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async get(id: any) {
    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/${id}/get`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async add(data: any) {
    const url = `${domain}/${this.namespace}/add`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async update(id: any, data: any) {
    const url = `${domain}/${this.namespace}/${id}/update`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async addEntity(businessId: any, data: any) {
    const url = `${domain}/${this.namespace}/${businessId}/addEntity`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async updateEntity(businessId: any, entityId: any, data: any) {
    const url = `${domain}/${this.namespace}/${businessId}/${entityId}/updateEntity`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async getAllEntity(id: any) {
    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/${id}/getAllEntity`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async listEntity(id: any) {
    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/${id}/listEntity`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async addStore(businessId: any, data: any) {
    const url = `${domain}/${this.namespace}/${businessId}/addStore`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async updateStore(businessId: any, storeId: any, data: any) {
    const url = `${domain}/${this.namespace}/${businessId}/${storeId}/updateStore`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async allStoreList() {
    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/allStoreList`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async storeList(id: any) {
    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/${id}/storeList`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async myStores() {
    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/myStores`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }


  async businessList() {
    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/businessList`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async invoicesList(json = {}) {
    const params = json || {};
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/invoicesList`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async invoiceViewById(data: any) {

    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/invoiceViewById`;
    return this.http.post(url, { data }, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async invoiceStatusUpdate(data: any) {

    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/invoiceStatusUpdate`;
    return this.http.post(url, { data }, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }


  errorHandle(err: any) {
    this.b.loadLoading(false);
    let message = err.error ? err.error.message : err.message;
    if (!message) message = err.error ? err.error : 'unknown error';

    this.b.toast(`${err.status}: ${message}`, 5000, `danger`);
  }
}
